import styled from 'styled-components'

import { TypeStyle, timingDefault } from '@syconium/little-miss-figgy'

export const CaratIconWrapper = styled.div<{
  isRotated: boolean
}>`
  transform: rotate(${o => (o.isRotated ? '90deg' : '0deg')});
  transition: transform ${timingDefault} ease;
`

export const FilterInputExpansionPanelWrapper = styled.div`
  border-bottom: 1px solid ${o => o.theme.color.deprecated.stoneLight};
`

export const FilterInputSummaryWrapper = styled.div`
  cursor: pointer;
  overflow-x: hidden;

  &:hover {
    color: ${o => o.theme.color.deprecated.obsidianLighter};

    svg > path {
      stroke: ${o => o.theme.color.deprecated.obsidianLighter};
    }
  }
`

export const FilterInputSummary = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 24px 0;
  width: 100%;
`

export const FilterInputLabel = styled.h3`
  ${TypeStyle.css.headlineExtraExtraSmall}
  text-transform: uppercase;
`

export const FilterInputDetails = styled.div`
  padding-bottom: 24px;
`
